var map = {
	"./china-cover.jpg": 483,
	"./china-high-speed-line-cover.jpg": 484,
	"./david-edelstein-N4DbvTUDikw-unsplash.jpg": 485,
	"./dong-xie-1vwOXJXxbrE-unsplash.jpg": 486,
	"./epaper-background-image.jpeg": 487,
	"./filios-sazeides-lg3TETZvqv4-unsplash.jpg": 488,
	"./finland-cover.jpg": 489,
	"./hanson-lu-_8EFj6ISA08-unsplash.jpg": 490,
	"./homestay_china.jpg": 491,
	"./homestay_japan.jpg": 492,
	"./homestay_taiwan.jpg": 493,
	"./img_about_us.jpg": 494,
	"./img_car_1_desktop.png": 495,
	"./img_car_2_desktop.png": 496,
	"./img_car_3_desktop.png": 497,
	"./img_login.png": 498,
	"./img_taiwan.jpg": 499,
	"./japan-cover.jpg": 500,
	"./kevin-healy-Yd2ohmtMmKM-unsplash.jpg": 501,
	"./korea-cover.jpg": 502,
	"./mesut-kaya-eOcyhe5-9sQ-unsplash.jpg": 503,
	"./rawkkim-KKz6NgO69yQ-unsplash.jpg": 504,
	"./remi-yuan-JMB3Efb8yoQ-unsplash.jpg": 505,
	"./taiwan-cover.jpg": 506,
	"./thomas-tucker-au3CYbd7vCU-unsplash.jpg": 507,
	"./tsaiga-qhQEyyHWrAQ-unsplash.jpg": 508,
	"./wishlist_banner.jpg": 509
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 482;